import { Tab } from '@mui/material';
import styled from 'styled-components';

export const StyledTab = styled(Tab)`
  && {
    ${({ theme }) => theme.typography.p7};
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3rem;
    padding: 0;

    svg:not(.tab-additional-info) {
      width: 1rem;
      height: 1rem;
      color: ${({ theme }) => theme.palette.primary.main};

      &.close-icon {
        color: ${({ theme }) => theme.palette.secondary.main};

        &:hover {
          color: ${({ theme }) => theme.palette.secondary.dark};
        }
      }
    }
  }
`;
